(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-collection-grid-products"] && !Shopify.designMode) return;
  try {
    function alignProductCardRatings(grid) {
        const cards = [...grid.querySelectorAll('.mm-product-card')];
        const rowMap = new Map();
        cards.forEach(card => {
            const top = Math.round(card.getBoundingClientRect().top);
            if (!rowMap.has(top)) rowMap.set(top, []);
            rowMap.get(top).push(card);
        });
        rowMap.forEach(rowCards => {
            const rowHasRating = rowCards.some(card => card.querySelector('.mm-ratings-wrapper'));
            rowCards.forEach(card => {
                const ratingDiv = card.querySelector('.mm-product-card-content-info-rating');
                if (ratingDiv) {
                    ratingDiv.style.minHeight = rowHasRating ? '20px' : '';
                    ratingDiv.style.display = rowHasRating ? '' : 'none';
                }
            });
        });
    }

    function runOnAllGrids() {
        document.querySelectorAll('[data-collection-grid]').forEach(grid => {
            alignProductCardRatings(grid);
        });
    }

    document.addEventListener('DOMContentLoaded', runOnAllGrids);

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(runOnAllGrids, 150);
    });
  } catch(e) { console.error(e); }
})();

})();
